import { DesignChannel } from 'components/NewFileModal/Types'
import { PlatformLimits } from 'components/ValidationBanner/utils'

export const mapDesignChannelToPlatform = (channel: DesignChannel): PlatformLimits | undefined => {
  switch (channel) {
    case DesignChannel.InstagramPost:
    case DesignChannel.InstagramStory:
    case DesignChannel.InstagramReel:
      return 'instagram'
    case DesignChannel.FacebookPost:
    case DesignChannel.FacebookCover:
    case DesignChannel.FacebookProfilePicture:
    case DesignChannel.FacebookMarketplace:
      return 'facebook'
    case DesignChannel.LinkedInPost:
    case DesignChannel.LinkedInBanner:
    case DesignChannel.LinkedInProfilePicture:
      return 'linkedin'
    case DesignChannel.TwitterPost:
    case DesignChannel.TwitterProfilePicture:
    case DesignChannel.TwitterCoverImage:
      return 'x'
    default:
      return undefined
  }
}
